import axios from 'axios';

class FileService {
	downloadFile(file, handleProgress) {
		return axios({
			url: file.url,
			method: 'GET',
			responseType: 'blob',
			onDownloadProgress: (progressEvent) => {
				handleProgress(file, progressEvent);
			},
		})
			.then(res => res.data);
	}
}

export default new FileService();
